<template>
  <div class="accodion_box accodion_payment apay-loose">
    <div class="accodion_box_tit">
      <a href="#target_payment" data-toggle="collapse" aria-expanded="true">
        <div class="panel-title">
          <span class="text-uppercase accordion-header-text"
            >자동 결제수단 등록</span
          >
          <span class="pull-right icon-arr" />
        </div>
      </a>
    </div>
    <div
      id="target_payment"
      class="accodion_box_cont0 collapse in"
      role="tabpanel"
      aria-expanded="true"
    >
      <!-- 암웨이페이 -->
      <amway-pay
        :style="styleAmwayPaymentBackgroundColor"
        :payment-method-info="paymentMethodInfo"
        :amway-pay-methods="amwayPayMethods"
        @update-payment-info="updateAmwayPayMethodInfo"
        @update-receipt-info="$emit('update-receipt-info', $event)"
        @save-data="$emit('save-data')"
      />
      <!-- 다른 결제수단 -->
      <other-pay
        :payment-method-info="paymentMethodInfo"
        :style="styleOtherPaymentBackgroundColor"
        @update-payment-info="updateOtherPayMethodInfo"
        @toggle-other-pay="toggleOtherPay"
        @update-receipt-info="$emit('update-receipt-info', $event)"
        @save-data="$emit('save-data')"
      />
    </div>
  </div>
</template>
<script>
import { PAYMENT_METHODS } from "@/utils/constants";
import AmwayPay from "@/views/composition/payment/AmwayPay";
import OtherPay from "@/views/composition/payment/OtherPay";
import { mapGetters } from "vuex";

export default {
  name: "PaymentMethods",
  components: { OtherPay, AmwayPay },
  props: {
    amwayPayMethods: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedPaymentMethod: "",
      selectedOtherPayMethod: "",
      selectedAmwayPayMethod: "",
    };
  },
  mounted() {
    if (this.currentPaymentMethod != null) {
      this.selectedPaymentMethod = this.currentPaymentMethod;
    }
    if (this.currentOtherPayMethod != null) {
      this.selectedOtherPayMethod = this.currentOtherPayMethod;
    }
    if (this.currentAmwayPayMethod != null) {
      this.selectedAmwayPayMethod = this.currentAmwayPayMethod;
    }
  },
  computed: {
    ...mapGetters({
      currentPaymentMethod: "payment/currentPaymentMethod",
      currentOtherPayMethod: "payment/currentOtherPayMethod",
      currentAmwayPayMethod: "payment/currentAmwayPayMethod",
    }),
    styleOtherPaymentBackgroundColor() {
      return this.selectedPaymentMethod === PAYMENT_METHODS.NORMAL
        ? { backgroundColor: "#f4f4f4" }
        : { backgroundColor: "#fff" };
    },
    styleAmwayPaymentBackgroundColor() {
      return this.selectedPaymentMethod === PAYMENT_METHODS.AMWAY_PAY
        ? { backgroundColor: "#f4f4f4" }
        : { backgroundColor: "#fff" };
    },
    paymentMethodInfo() {
      return {
        paymentMethod: this.selectedPaymentMethod,
        otherPaymentMethod: this.selectedOtherPayMethod,
        amwayPayMethod: this.selectedAmwayPayMethod,
      };
    },
  },
  watch: {
    paymentMethodInfo(newValue) {
      this.$emit("update-cart-info", newValue);
    },
  },
  methods: {
    updateAmwayPayMethodInfo(data) {
      this.selectedPaymentMethod = data.selectedPaymentMethod;
      this.selectedAmwayPayMethod = data.selectedAmwayPayMethod;
    },
    updateOtherPayMethodInfo(data) {
      this.selectedPaymentMethod = data.selectedPaymentMethod;
      this.selectedOtherPayMethod = data.selectedOtherPayMethod;
    },
    toggleOtherPay(checked) {
      this.selectedPaymentMethod = checked
        ? PAYMENT_METHODS.NORMAL
        : PAYMENT_METHODS.AMWAY_PAY;
    },
  },
};
</script>

<style scoped>
</style>